<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de grupo">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'transporte-paciente-grupo-create' })"
                    autorize="store-transporte-paciente-grupo"
                    color="primary"
                >
                    Cadastrar grupo
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import List from '@/components/transporte-paciente/grupo/List'

export default {
    components: { List },
}
</script>